import { Link } from '../app/navigation';

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link href="/" className={`brand ${compact ? 'brand--compact' : ''}`} aria-label="수업마침 홈">
      <svg className="brand__mark" viewBox="0 0 64 64" role="img" aria-label="수업표의 마지막 행이 마감선에 닿는 수업마침 상징">
        <path d="M10 14h32M10 25h38M10 36h29M10 47h40" />
        <path className="brand__close-line" d="M49 11v39" />
      </svg>
      <span className="brand__word">수업마침</span>
    </Link>
  );
}
